import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';
import EmployeeListTable from 'Employee/components/employee-list/EmployeeListTable';
import employeeStatusFilters from 'Employee/constants/employeeStatusFilters';

const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    background-color: ${colors.DARK_GRAY};
    padding: 8px 0;
    border-radius: 4px;
`;

const EmployeeList = ({
    selectedStatus,
    employees,
    onEmployeeActivate,
    onEmployeeDeactivate,
}) => {
    let filteredEmployees = [...employees];

    if (selectedStatus === employeeStatusFilters.ACTIVE) {
        filteredEmployees = filteredEmployees.filter(
            employee => employee.isEnabled,
        );
    } else {
        filteredEmployees = filteredEmployees.filter(
            employee => !employee.isEnabled,
        );
    }

    return (
        <Content>
            <EmployeeListTable
                employees={filteredEmployees}
                onActivate={onEmployeeActivate}
                onDeactivate={onEmployeeDeactivate}
            />
        </Content>
    );
};

EmployeeList.propTypes = {
    selectedStatus: PropTypes.string.isRequired,
    employees: PropTypes.array.isRequired,
    onEmployeeActivate: PropTypes.func.isRequired,
    onEmployeeDeactivate: PropTypes.func.isRequired,
};

export default EmployeeList;
